(function () {
  'use strict';

  angular
      .module('tfc.Nav')
      .factory('TextUtil', TextUtil);

  // @ngInject
  function TextUtil($injector) {

    var translateFilter;
    if ($injector.has('translateFilter')) {
      translateFilter = $injector.get('translateFilter');
    }

    return {
      translateOr : translateOr
    };

    /**
     * @name TextUtil#translateOr
     *
     * Uses angular-translate to translate the `translationId` or calls the `fallbackFn`
     * with `values`.
     *
     * @param translationId
     * @param [values]
     * @param fallbackFn
     * @returns String The result of the translation, or the return value of `fallbackFn`
     *                 if angular-translate is not present
     */
    function translateOr(translationId, values, fallbackFn) {
      if (arguments.length < 2) {
        throw new Error('translateOr requires at least a translationId and fallback function,' +
            'with optional values in between.');
      }
      if (arguments.length === 2) {
        fallbackFn = values;
        values = undefined;
      }
      if (translateFilter) {
        return translateFilter(translationId, values);
      } else {
        return fallbackFn(values);
      }
    }
  }

})();
